import { createSlice } from "@reduxjs/toolkit";
import instance from "../../api/api.js";

export const fectchClients = () => async (dispatch) => {
  try {
    const response = await instance.get("clients");
    console.log("REPONSEClients", response);
    dispatch(fetchClientsFulfilled(response?.data.data));
  } catch (error) {
    console.log();
  }
};
// export const removeFlagCommandes = (payload) => async (dispatch) => {
//   try {
//     const response = await instance.post("/updateFlagCommande/" + payload);
//     console.log("REPONSEBIENS", response);
//     if (response.status === true) {
//       dispatch(removeItem());
//     }
//   } catch (error) {
//     console.log();
//   }
// };
export const clientsReducer = createSlice({
  name: "Clients",
  initialState: { Clients: [],totalClients:null },
  reducers: {
    removeItem: (state) => {
      const nouveau_length = state.commande_length - 1;
      return { ...state, commande_length: nouveau_length };
    },
    fetchClientsFulfilled: (state, action) => {
      return {...state,Clients:action.payload,totalClients:action.payload.length}
    },
  },
});

export const { handleTotalNew, fetchClientsFulfilled, removeItem } =
  clientsReducer.actions;
export default clientsReducer.reducer;
